import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { SectionHeader } from "@/components/site/Reveal";
import { SERVICE_ICONS } from "@/data";

export const Services = () => {
  const { t } = useLang();
  const scrollToContact = () => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="services" className="py-24 sm:py-32 bg-[#111827] relative noise-overlay" data-testid="services-section">
      <div className="container-x">
        <SectionHeader tag={t.services.tag} title={t.services.title} subtitle={t.services.subtitle} />

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-14">
          {t.services.items.map((s, i) => {
            const Icon = SERVICE_ICONS[s.key];
            return (
              <motion.button
                key={s.key}
                data-testid={`service-card-${s.key}`}
                onClick={scrollToContact}
                initial={{ opacity: 0, y: 26 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.55, delay: (i % 3) * 0.08, ease: [0.16, 1, 0.3, 1] }}
                className="card-lift group text-left rounded-2xl border border-white/10 bg-[#1C2539] p-7 relative overflow-hidden"
              >
                <div className="flex items-center justify-between">
                  <span className="grid place-items-center h-14 w-14 rounded-xl bg-[#E85D04]/12 text-[#FF8C42] group-hover:bg-[#E85D04] group-hover:text-white transition-colors">
                    {Icon && <Icon className="h-6 w-6" />}
                  </span>
                  <ArrowUpRight className="h-5 w-5 text-white/25 group-hover:text-[#FF8C42] transition-colors" />
                </div>
                <h3 className="font-display font-bold text-xl mt-6">{s.title}</h3>
                <p className="text-[#9CA3AF] text-sm mt-2.5 leading-relaxed">{s.desc}</p>
              </motion.button>
            );
          })}
        </div>
      </div>
    </section>
  );
};
